const AllocationTypes = {
  STANDARD: 'Standard',
  CRISIS: 'Crisis',
  ALL: 'All',
} as const;

export default AllocationTypes;
